export default __webpack_public_path__ + "static/media/group.dc6dcfce.jpg";